export default __webpack_public_path__ + "static/media/excelsior.99bc98a5.svg";